// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Text_wrapper__Vshqt","post":"Text_post__PIcQT"};